export default __webpack_public_path__ + "static/media/background6.bfdb6b6d.jpg";